<form #formContact="ngForm" (ngSubmit)="formContact.form.valid && generateRecaptcha(formContact)" novalidate>
  <h3 class="mb-5">{{ "accounts.contact_us.title" | translate }}</h3>
  <div class="row justify-content-center">

    <div class="col-12 col-md-6">
      <label class="control-label" for="comments">{{ "accounts.contact_us.comments" | translate }}</label>
      <textarea class="form-control" id="comments" name="comments" [(ngModel)]="contactData.comments" #comments="ngModel" [ngClass]="inputFieldCss(comments, formContact)" required></textarea>
      <app-field-error-display [control]="comments" [form]="formContact"></app-field-error-display>
    </div>
  </div>
  <div class="row justify-content-center mt-3">
    <i class="fas fa-phone-alt text-primary fa-3x"></i>
  </div>
  <div class="row justify-content-center mt-3">
    <p>{{this.configurationService.account.callCenterNumber}}</p>
  </div>
  <div class="text-center">
    <button class="btn btn-primary mt-4 mb-2 pr-5 pl-5" type="submit">{{ "accounts.contact_us.send" | translate }}</button>
  </div>
</form>
